import { handleActions, createAction } from 'redux-actions'

const initialState = {
  signInError: false,
  newPasswordFormError: false,
  emailSent: false,
  passwordUpdated: false,
};

export const SIGN_IN = createAction('SIGN_IN');
export const SIGN_IN_SUCCESS = createAction('SIGN_IN_SUCCESS');
export const SIGN_IN_FAIL = createAction('SIGN_IN_FAIL');
export const SIGN_OUT = createAction('SIGN_OUT');
export const SIGN_OUT_SUCCESS = createAction('SIGN_OUT_SUCCESS');
export const SIGN_OUT_FAIL = createAction('SIGN_OUT_FAIL');
export const NEW_PASSWORD_REQUEST = createAction('NEW_PASSWORD_REQUEST');
export const NEW_PASSWORD_REQUEST_SUCCESS = createAction('NEW_PASSWORD_REQUEST_SUCCESS');
export const NEW_PASSWORD_REQUEST_FAIL = createAction('NEW_PASSWORD_REQUEST_FAIL');
export const RESET_PASSWORD = createAction('RESET_PASSWORD');
export const RESET_PASSWORD_SUCCESS = createAction('RESET_PASSWORD_SUCCESS');
export const RESET_PASSWORD_FAIL = createAction('RESET_PASSWORD_FAIL');

const authReducer = handleActions({
  [SIGN_IN_FAIL]: (state) => {
    return { ...state, signInError: true, };
  },
  [NEW_PASSWORD_REQUEST_SUCCESS]: (state) => {
    return { ...state, emailSent: true, newPasswordFormError: false, };
  },
  [NEW_PASSWORD_REQUEST_FAIL]: (state) => {
    return { ...state, newPasswordFormError: true, };
  },
  [RESET_PASSWORD_SUCCESS]: (state) => {
    return { ...state, passwordUpdated: true, };
  },
}, initialState);


export default authReducer;

